
import ArchiveBook from "../../../assets/filled/ArchiveBook.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArchiveBookIcon({ className, dataTestid = "ArchiveBookIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArchiveBook data-testid={dataTestid} className={classes} {...rest} />
  );
}
